var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{staticClass:"tooltip"},[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.$trans(_vm.title)))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }